import { queryOptions } from '@tanstack/react-query'

import { createApiMethod, type } from './utils/createApiMethod'

export interface SignatureCourseListItem {
  description: string
  duration: number
  image_id: string
  num_completed_topics: number
  num_of_points: number
  num_topics: number
  slug: string
  title: string
}

export interface SignatureCoursesAllAvailableResponse {
  signature_courses: SignatureCourseListItem[]
}

export const signatureCourses = {
  allAvailable: createApiMethod({
    method: 'GET',
    path: '/signature-courses/all-available',
    response: type<SignatureCoursesAllAvailableResponse>(),
  }),
}

export const signatureCoursesQueries = {
  all: () => ['signature-courses'] as const,
  allAvailable: () =>
    queryOptions({
      queryKey: [...signatureCoursesQueries.all(), 'all-available'] as const,
      queryFn: () => signatureCourses.allAvailable(),
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    }),
}
